export default __webpack_public_path__ + "static/media/Nav-Settings.b5c10c39.svg";